<template>
  <div class="home">
    <XzjyIndex msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import XzjyIndex from '@/components/xzjyIndex.vue'

export default {
  name: 'Home',
  components: {
    XzjyIndex
  }
}
</script>
